import * as LoginReducer from "./loginService/reducers";
import * as LoginType from "./loginService/types";
import * as ForgotPasswordType from "./forgotPasswordService/types";
import * as ForgotPasswordReducer from "./forgotPasswordService/reducers";
import * as MonitorReducer from "./monitorService/reducers";
import * as MonitorType from "./monitorService/types";
import * as AlertType from "./AlertsService/types";
import * as AlertReducer from "./AlertsService/reducers";
import * as ConfigurationType from "./configurationService/types";
import * as ConfigurationReducer from "./configurationService/reducers";
import * as CreditType from "./credit/types";
import * as CreditReducer from "./credit/reducers";
import * as PasswordManagerReducer from "./passwordManagerService/reducers";
import * as PasswordManagerType from "./passwordManagerService/types";
import * as NextStepFlowReducer from "./nextStepFlowService/reducers";
import * as NextStepFlowType from "./nextStepFlowService/types";
import * as TransactionReducer from "./transaction/reducers";
import * as AccountSummaryType from "./transaction/types";
import * as BreachesAndScamsType from "./breachesAndScamsService/types";
import * as BreachesAndScamsReducer from "./breachesAndScamsService/reducers";
import * as EducationType from "./education/types";
import * as EducationReducer from "./education/reducers";
import * as CyberRiskProfileType from "./cyberRiskProfile/types";
import * as CyberRiskProfileReducer from "./cyberRiskProfile/reducers";
import * as MonitoringType from "./monitoringInfoService/types";
import * as MonitoringReducer from "./monitoringInfoService/reducers";
import * as SecureStorageType from "./secureStorageService/types";
import * as SecureStorageReducer from "./secureStorageService/reducers";
import * as WebinarsType from "./webinars/types";
import * as WebinarsReducer from "./webinars/reducers";
import * as InfographicsType from "./infographics/types";
import * as InfographicsReducer from "./infographics/reducers";
import * as RegistrationReducer from "./registrationService/reducers";
import * as RegistrationType from "./registrationService/types";
import * as PackageUpgradeType from "./packageUpgradeService/types";
import * as PackageUpgradeReducer from "./packageUpgradeService/reducers";
import * as ProtectionPlanType from "./protectionPlanService/ezs/types";
import * as ProtectionPlanReducer from "./protectionPlanService/ezs/reducers";
import * as IDFProtectionPlanType from "./protectionPlanService/idf/types";
import * as IDFProtectionPlanReducer from "./protectionPlanService/idf/reducers";
import * as BusinessProtectionPlanType from "./protectionPlanService/business/types";
import * as BusinessProtectionPlanReducer from "./protectionPlanService/business/reducers";
import * as BannerMessageType from "./bannerMessage/types";
import * as BannerMessageReducer from "./bannerMessage/reducers";
import * as DownloadAppType from "./downloadApp/types";
import * as DownloadAppReducer from "./downloadApp/reducers";
import * as CSID from "./csid/types";
import * as CSIDReducer from "./csid/reducers";
import * as FamilyServiceReducer from "./familyService/reducers";
import * as FamilyServiceType from "./familyService/types";
import * as DashboardServiceReducer from "./dashboardService/reducers";
import * as DashboardServiceType from "./dashboardService/types";
import * as ChildMonitoringServiceReducer from "./childMonitoring/reducers";
import * as ChildMonitoringServiceType from "./childMonitoring/types";
import * as MyAccountServiceReducer from "./myAccount/reducers";
import * as MyAccountServiceType from "./myAccount/types";
import * as SocialMediaReducer from "./socialMediaMonitoringService/reducers";
import * as SocialMediaTypes from "./socialMediaMonitoringService/types";
import * as BusinessCreditReportReducer from "./businessCreditReportService/reducers";
import * as BusinessCreditReportTypes from "./businessCreditReportService/types";
import * as SecurityAssesmentReducer from "./securityAssesmentService/reducers";
import * as SecurityAsesmentTypes from "./securityAssesmentService/types";
import * as BusinessProfileReducer from "./businessProfileService/reducers";
import * as BusinessProfileTypes from "./businessProfileService/types";
import * as ProductFeatureReducer from "./productFeatureService/reducers";
import * as ProductFeatureTypes from "./productFeatureService/types";
import * as RepIQPresetProfileTypes from "./repIQPresetProfile/types";
import * as RepIQPresetProfileReducer from "./repIQPresetProfile/reducers";
import * as BreachSummaryTypes from "./breachService/types";
import * as BreachReducers from "./breachService/reducers";
import * as RepIQSocialMediaStatusType from "./repIQSocialMediaStatus/types";
import * as RepIQSocialMediaStatusReducer from "./repIQSocialMediaStatus/reducers";
import * as RepIQSocialMediaAnalysisHistoryType from "./repIQSocialMediaAnalysisHistory/types";
import * as RepIQSocialMediaAnalysisHistoryReducer from "./repIQSocialMediaAnalysisHistory/reducers";
import * as RepIQSelectedSocialMediaType from "./repIQSelectedSocialMedia/types";
import * as RepIQSelectedSocialMediaReducer from "./repIQSelectedSocialMedia/reducers";

import * as UserServiceType from "./userService/types";
import * as UserServiceReducer from "./userService/reducers";

import * as SalesLandingTestimonialsType from "./salesLandingStore/testimonials/types";
import * as SalesLandingTestimonialsReducer from "./salesLandingStore/testimonials/reducer";

import * as TUServiceType from "./dashboardService/types";
import * as TUServiceReducer from "./dashboardService/reducers";
import * as BillingStatusType from "./BillingStatusService/types";
import * as BillingStatusReducer from "./BillingStatusService/reducers";

// The top-level state object
export interface ApplicationState {
    loggedInUser: LoginType.ILoggedInUserState | undefined;
    monitorData: MonitorType.IMonitorState | undefined;
    monitoringState: MonitoringType.IMonitoringState | undefined;
    alertState: AlertType.IAlertState | undefined;
    displayOption: RegistrationType.IRegistrationState | undefined;
    configurationState: ConfigurationType.IConfigurationState | undefined;
    passwordManagerState: PasswordManagerType.IPasswordManagerState | undefined;
    nextStepFlowState: NextStepFlowType.INextStepFlowState | undefined;
    forgotPasswordState: ForgotPasswordType.IForgotPasswordState | undefined;
    creditHistoryData: CreditType.ICreditHistoryState;
    creditState: CreditType.ICreditDataState;
    oneTimeCreditData: CreditType.IOneTimeCreditState;
    dailyCreditScoreData: CreditType.IDailyCreditState;
    creditAuthData: CreditType.ICreditAuthState;
    accountSummaryData: AccountSummaryType.IAccountSummaryState;
    recentTransactionData: AccountSummaryType.IRecentTransactionState;
    transactionChartData: AccountSummaryType.ITransactionChartState;
    breachesAndScamsState: BreachesAndScamsType.IBreachesAndScamsState | undefined;
    educationState: EducationType.IEducationState | undefined;
    cyberRiskAssessmentState: CyberRiskProfileType.ICyberRiskAssessmentState | undefined;
    // secureStorageState: SecureStorageType.ISecureStorageState | undefined;
    webinarsState: WebinarsType.IWebinarsState | undefined;
    infographicsState: InfographicsType.IInfographicsState | undefined;
    documentsAndImagesState: SecureStorageType.IDocumentsAndImagesState | undefined;
    packageUpgradeState: PackageUpgradeType.IPackageUpgradeState | undefined;
    protectionPlanState: ProtectionPlanType.IProtectionPlanState;
    protectionPlanIdfState: IDFProtectionPlanType.IProtectionPlanIDFState;
    protectionPlanBusinessState: BusinessProtectionPlanType.IProtectionPlanBusinessState;
    billingInfoState: IDFProtectionPlanType.IBillingInfoState;
    checkContractChangeState: ProtectionPlanType.ICheckContractChangeState;
    alertMessageBannerState: BannerMessageType.IAlertMessageBannerState | undefined;
    downloadAppState: DownloadAppType.IDownloadAppState | undefined;
    csidUserStatusState: CSID.ICSIDUserStatusState | undefined;
    familyServiceState: FamilyServiceType.IFamilyServiceState | undefined;
    dashboardServiceState: DashboardServiceType.IDashboardServiceState | undefined;
    childMonitoringServiceState: ChildMonitoringServiceType.IChildMonitoringServiceState | undefined;
    myAccountServiceState: MyAccountServiceType.ImyAccountState | undefined;
    socialMediaState: SocialMediaTypes.ISocialMediaState | undefined;
    businessCreditReportState: BusinessCreditReportTypes.IBusinessCreditReportState | undefined;
    securityAssesmentState: SecurityAsesmentTypes.ISecurityAssesmentState | undefined;
    businessProfileState: BusinessProfileTypes.IBusinessProfileState;
    productFeatureState: ProductFeatureTypes.IProductFeatureState;
    repIQPresetProfileState: RepIQPresetProfileTypes.IPresetProfileState;
    breachSummaryState: BreachSummaryTypes.IBreachState;
    breachServiceState: BreachSummaryTypes.IBreachServiceState;
    repIQSocialMediaStatusState: RepIQSocialMediaStatusType.ISocialMediaStatusState;
    repIQSocialMediaAnalysisHistoryState: RepIQSocialMediaAnalysisHistoryType.ISocialMediaAnalysisHistoryState;
    repIQSelectedSocialMediaState: RepIQSelectedSocialMediaType.ISelectedSocialMediaState;
    userServiceState: UserServiceType.IUserServiceState | undefined;
    tuServicesState: TUServiceType.ITUServiceState | undefined;
    testimonialsState: SalesLandingTestimonialsType.ITestimonialsState | undefined;
    billingStatusState: BillingStatusType.IBillingStatusState | undefined;
    creditEnrollmentDetailsState: CreditType.ICreditEnrollmentDetailsState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    loggedInUser: LoginReducer.reducer,
    monitorData: MonitorReducer.monitorReducer,
    monitoringState: MonitoringReducer.reducer,
    alertState: AlertReducer.reducer,
    registrationData: RegistrationReducer.registrationDataReducer,
    configurationState: ConfigurationReducer.configurationReducer,
    creditHistoryData: CreditReducer.creditHistoryReducer,
    creditState: CreditReducer.creditDataReducer,
    oneTimeCreditData: CreditReducer.oneTimeCreditReducer,
    dailyCreditScoreData: CreditReducer.dailyCreditReducer,
    creditAuthData: CreditReducer.creditAuthReducer,
    passwordManagerState: PasswordManagerReducer.passwordManagerReducer,
    nextStepFlowState: NextStepFlowReducer.nextStepFlowReducer,
    forgotPasswordState: ForgotPasswordReducer.reducer,
    accountSummaryData: TransactionReducer.accountSummaryReducer,
    recentTransactionData: TransactionReducer.transactionActivityReducer,
    transactionChartData: TransactionReducer.transactionChartReducer,
    breachesAndScamsState: BreachesAndScamsReducer.reducer,
    educationState: EducationReducer.reducer,
    cyberRiskAssessmentState: CyberRiskProfileReducer.reducer,
    // secureStorageState: SecureStorageReducer.reducer,
    webinarsState: WebinarsReducer.reducer,
    infographicsState: InfographicsReducer.reducer,
    documentsAndImagesState: SecureStorageReducer.documentsAndImagesReducer,
    packageUpgradeState: PackageUpgradeReducer.reducer,
    protectionPlanState: ProtectionPlanReducer.protectionPlanReducer,
    protectionPlanIdfState: IDFProtectionPlanReducer.protectionPlanIDFReducer,
    protectionPlanBusinessState: BusinessProtectionPlanReducer.protectionPlanReducer,
    checkContractChangeState: ProtectionPlanReducer.checkContractChangeReducer,
    billingInfoState: IDFProtectionPlanReducer.billingInfoReducer,
    alertMessageBannerState: BannerMessageReducer.reducer,
    downloadAppState: DownloadAppReducer.reducer,
    csidUserStatusState: CSIDReducer.CSIDUserStatusReducer,
    familyServiceState: FamilyServiceReducer.reducer,
    dashboardServiceState: DashboardServiceReducer.reducer,
    childMonitoringServiceState: ChildMonitoringServiceReducer.reducer,
    myAccountServiceState: MyAccountServiceReducer.reducer,
    socialMediaState: SocialMediaReducer.socialMediaReducer,
    businessCreditReportState: BusinessCreditReportReducer.businessCreditReportReducer,
    securityAssesmentState: SecurityAssesmentReducer.securityAssesmentReducer,
    businessProfileState: BusinessProfileReducer.businessProfileReducer,
    productFeatureState: ProductFeatureReducer.productFeatureReducer,
    repIQPresetProfileState: RepIQPresetProfileReducer.reducer,
    breachSummaryState: BreachReducers.breachSummaryReducer,
    breachServiceState: BreachReducers.breachServiceAndCatalogReducer,
    repIQSocialMediaStatusState: RepIQSocialMediaStatusReducer.reducer,
    repIQSocialMediaAnalysisHistoryState: RepIQSocialMediaAnalysisHistoryReducer.reducer,
    repIQSelectedSocialMediaState: RepIQSelectedSocialMediaReducer.reducer,
    userServiceState: UserServiceReducer.userServiceReducer,
    tuServicesState: TUServiceReducer.tuServicesReducer,
    testimonialsState: SalesLandingTestimonialsReducer.reducer,
    billingStatusState: BillingStatusReducer.reducer,
    creditEnrollmentDetailsState: CreditReducer.creditEnrollmentReducer
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
